import type { Term } from '../systems/EventBus';

export interface ScriptedBeat {
  id: string;
  fictionalMinutes: number;
  term: Term;
}

export const BEATS: readonly ScriptedBeat[] = [
  { id: 'beat-1-aging', fictionalMinutes: 540, term: 'aging-bucket' },
  { id: 'beat-2-dunning', fictionalMinutes: 570, term: 'dunning' },
  { id: 'beat-3-cash-app', fictionalMinutes: 630, term: 'cash-application' },
  { id: 'beat-4-short-pay', fictionalMinutes: 675, term: 'short-pay' },
  { id: 'beat-5-dispute', fictionalMinutes: 750, term: 'dispute' },
  { id: 'beat-6-promise-to-pay', fictionalMinutes: 840, term: 'promise-to-pay' },
  { id: 'beat-7-write-off', fictionalMinutes: 930, term: 'write-off' },
  { id: 'beat-8-dso', fictionalMinutes: 1015, term: 'dso' },
];
